import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import { Stack, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { ReviewAccess } from './caseState';

const since = (date?: string) => date ? ` · since ${DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_MED)}` : '';

const ReviewOwnership = ({ access }: { access: ReviewAccess }) => {
    if (!access.isMine && !access.claimedByOther) return null;
    const Icon = access.isMine ? PersonOutlineRoundedIcon : LockOutlinedIcon;

    return (
        <Stack direction='row' spacing={0.75} alignItems='center' sx={{ mt: 0.5, color: access.isMine ? 'primary.main' : 'warning.dark' }}>
            <Icon fontSize='small' aria-hidden />
            <Typography variant='body2' sx={{ fontWeight: 600, overflowWrap: 'anywhere' }}>
                {access.isMine ? `You are reviewing this case${since(access.claimedAt)}` : `${access.holderName} is reviewing${since(access.claimedAt)}`}
            </Typography>
        </Stack>
    );
};

export default ReviewOwnership;
